import React, { useContext, useMemo } from "react";
import Routes from "../modules/main/Routes";

export default function useRoutes(): typeof Routes {
 
  const routes = useMemo(() => {
    const _routes = [...Routes];
    return _routes;
  }, []);
  
  return routes;
}
